import { ChartOfAccountTypeEnum } from "@/features/chart-of-accounts";
import { AccountingActionEnum } from "./accounting-action-enum";

export const AccountingActionAllowedTypes = Object.freeze({
  // Barang & Jasa
  [AccountingActionEnum.INVENTORY]: [ChartOfAccountTypeEnum.INVENTORY],
  [AccountingActionEnum.SALES_REVENUE]: [
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
    ChartOfAccountTypeEnum.LONG_TERM_LIABILITIES,
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
  [AccountingActionEnum.SALES_RETURN]: [
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
  [AccountingActionEnum.SALES_DISCOUNT]: [
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
  [AccountingActionEnum.GOODS_IN_TRANSIT]: [ChartOfAccountTypeEnum.INVENTORY],
  [AccountingActionEnum.COST_OF_GOODS_SOLD]: [
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
  ],
  [AccountingActionEnum.PURCHASE_RETURN]: [
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.INVENTORY,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
    ChartOfAccountTypeEnum.EXPENSES,
    ChartOfAccountTypeEnum.OTHER_EXPENSES,
  ],
  [AccountingActionEnum.EXPENSE]: [
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.INVENTORY,
    ChartOfAccountTypeEnum.OTHER_ASSETS,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
    ChartOfAccountTypeEnum.EXPENSES,
    ChartOfAccountTypeEnum.OTHER_EXPENSES,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
  [AccountingActionEnum.UNBILLED_PAYABLES]: [
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
  ],

  // Perusahaan
  [AccountingActionEnum.OPENING_BALANCE_EQUITY]: [
    ChartOfAccountTypeEnum.EQUITY,
  ],
  [AccountingActionEnum.RETAINED_EARNINGS]: [ChartOfAccountTypeEnum.EQUITY],
  [AccountingActionEnum.INCOME_TAX_EXPENSE]: [
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
    ChartOfAccountTypeEnum.EXPENSES,
    ChartOfAccountTypeEnum.OTHER_EXPENSES,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
  [AccountingActionEnum.PPH21_PAYABLE]: [
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
  ],
  [AccountingActionEnum.PENSION_PAYABLE]: [
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
  ],
  [AccountingActionEnum.HEALTH_INSURANCE_PAYABLE]: [
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
  ],

  // Peminjaman Karyawan
  [AccountingActionEnum.EMPLOYEE_LOAN_RECEIVABLE]: [
    ChartOfAccountTypeEnum.ACCOUNTS_RECEIVABLE,
  ],
  [AccountingActionEnum.LOAN_INTEREST_RECEIVABLE]: [
    ChartOfAccountTypeEnum.ACCOUNTS_RECEIVABLE,
  ],
  [AccountingActionEnum.DEFERRED_INTEREST_INCOME]: [
    ChartOfAccountTypeEnum.LONG_TERM_LIABILITIES,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
  ],
  [AccountingActionEnum.LOAN_INTEREST_INCOME]: [
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
  [AccountingActionEnum.LOAN_PENALTY_INCOME]: [
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],

  // Penjualan/Pembelian
  [AccountingActionEnum.PAYMENT_DISCOUNT]: [
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.INVENTORY,
    ChartOfAccountTypeEnum.FIXED_ASSETS,
    ChartOfAccountTypeEnum.ACCUMULATED_DEPRECIATION,
    ChartOfAccountTypeEnum.OTHER_ASSETS,
    ChartOfAccountTypeEnum.LONG_TERM_LIABILITIES,
    ChartOfAccountTypeEnum.CURRENT_LIABILITIES,
    ChartOfAccountTypeEnum.EQUITY,
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
    ChartOfAccountTypeEnum.EXPENSES,
    ChartOfAccountTypeEnum.OTHER_EXPENSES,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
  [AccountingActionEnum.TAX_ROUNDING_DIFFERENCE]: [
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
    ChartOfAccountTypeEnum.EXPENSES,
    ChartOfAccountTypeEnum.OTHER_EXPENSES,
  ],

  // Persediaan
  [AccountingActionEnum.INVENTORY_ADJUSTMENT]: [
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.INVENTORY,
    ChartOfAccountTypeEnum.EQUITY,
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
    ChartOfAccountTypeEnum.EXPENSES,
    ChartOfAccountTypeEnum.OTHER_EXPENSES,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
  [AccountingActionEnum.STOCK_OPNAME_VARIANCE]: [
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
    ChartOfAccountTypeEnum.EXPENSES,
    ChartOfAccountTypeEnum.OTHER_EXPENSES,
  ],
  [AccountingActionEnum.WORK_IN_PROGRESS]: [
    ChartOfAccountTypeEnum.OTHER_CURRENT_ASSETS,
    ChartOfAccountTypeEnum.INVENTORY,
    ChartOfAccountTypeEnum.EQUITY,
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
    ChartOfAccountTypeEnum.EXPENSES,
    ChartOfAccountTypeEnum.OTHER_EXPENSES,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
  [AccountingActionEnum.JOB_COST_VARIANCE]: [
    ChartOfAccountTypeEnum.REVENUE,
    ChartOfAccountTypeEnum.COST_OF_GOODS_SOLD,
    ChartOfAccountTypeEnum.EXPENSES,
    ChartOfAccountTypeEnum.OTHER_EXPENSES,
    ChartOfAccountTypeEnum.OTHER_INCOME,
  ],
});
